module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.activePanel) ? _c('div', {
    staticClass: "sideways-content-fold"
  }, [(_vm.process === 'form') ? _c('div', {
    staticClass: "portlet light bordered"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [_c('form', {
    attrs: {
      "role": "form",
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.inviteUser($event)
      }
    }
  }, [(_vm.errorMessage.length) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-close": "alert"
    },
    on: {
      "click": function($event) {
        _vm.clearError()
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-body invite-user-form"
  }, [_c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.invitedUser.email),
      expression: "invitedUser.email"
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.invitedUser.email.length
    },
    attrs: {
      "type": "email",
      "id": "invite_user_email"
    },
    domProps: {
      "value": (_vm.invitedUser.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.invitedUser, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "invite_user_email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v("Please make sure you enter a valid email address.")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.invitedUser.name.first_name),
      expression: "invitedUser.name.first_name"
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.invitedUser.name.first_name && _vm.invitedUser.name.first_name.length
    },
    attrs: {
      "type": "text",
      "id": "invite_user_first_name"
    },
    domProps: {
      "value": (_vm.invitedUser.name.first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.invitedUser.name, "first_name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "invite_user_first_name"
    }
  }, [_vm._v("First Name")]), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v("The user will get the opportunity to confirm this.")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.invitedUser.name.last_name),
      expression: "invitedUser.name.last_name"
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.invitedUser.name.last_name && _vm.invitedUser.name.last_name.length
    },
    attrs: {
      "type": "text",
      "id": "invite_user_last_name"
    },
    domProps: {
      "value": (_vm.invitedUser.name.last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.invitedUser.name, "last_name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "invite_user_last_name"
    }
  }, [_vm._v("Last Name")]), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v("The user will get the opportunity to confirm this.")])]), _vm._v(" "), (!_vm.locationId) ? _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('typeahead', {
    attrs: {
      "data": _vm.roles,
      "label": 'Role',
      "emitter": 'role',
      "objectKey": 'role_name'
    },
    on: {
      "role": _vm.updateRole,
      "onFocus": _vm.roleFocus
    }
  })], 1) : _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('typeahead', {
    attrs: {
      "data": _vm.locationRoles,
      "label": 'Location Role',
      "emitter": 'locationRole',
      "objectKey": 'role_name'
    },
    on: {
      "locationRole": _vm.updateLocationRole,
      "onFocus": _vm.locationRoleFocus
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-actions noborder invite-user-actions"
  }, [_c('button', {
    staticClass: "btn btn-default exit-invitation-setup",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closePanel()
      }
    }
  }, [_vm._v(" Return To Users Dashboard")]), _vm._v(" "), _c('button', {
    staticClass: "btn blue",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Submit")])])])])]) : _c('next-actions', {
    attrs: {
      "actionsList": _vm.inviteUserNextActions
    },
    on: {
      "runFunction": _vm.runFunction
    }
  })], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "caption"
  }, [_vm._v("\n\t\t\t\t\tInvite A User\n\t\t\t\t")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d8f21296!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/Users/components/InviteUser.vue
// module id = 460
// module chunks = 1